module.exports = __webpack_public_path__ + "static/QLD_Kindy_Approved_Logo-5adc3de14d870ceaecec3b1857ce35fa.png";